<div class="qc-lab-req">
    <form *ngIf="form" [formGroup]="form">
        <div class="grid">
            <div class="div1" style="padding: 24px 24px 0 24px">
                <div style="display: flex; justify-content: space-between">
                    <div>
                        <img
                            src="https://www.gtrsante.com/cdn/shop/files/gtr_new_blue.png?v=1702277688&width=300"
                            alt="gtrsante-img"
                            class="logo"
                        />
                    </div>
                    <div
                        style="
                            text-align: right;
                            font-size: 12px;
                            padding: 15px;
                        "
                    >
                        <div>West Island</div>
                        <div>Laval</div>
                        <div>Downtown Montreal</div>
                        <div>FSherbrooke, QC</div>
                    </div>
                </div>

                <div class="patient-form" formGroupName="patient">
                    <div>
                        <b style="font-size: 16px">PATIENT:</b>
                    </div>
                    <div style="display: flex; flex-wrap: nowrap">
                        <div style="width: 50%">
                            <div>
                                <input formControlName="name" type="text" />
                            </div>
                        </div>
                        <div style="width: 20%">
                            <div>
                                <input
                                    formControlName="firstName"
                                    type="text"
                                />
                            </div>
                        </div>
                        <div style="width: 30%">
                            <div>
                                <input formControlName="dob" type="text" />
                            </div>
                        </div>
                    </div>
                    <div class="divider"></div>
                    <div style="display: flex; flex-wrap: nowrap">
                        <div style="width: 50%">
                            <label>Name</label>
                        </div>
                        <div style="width: 20%">
                            <label>First Name</label>
                        </div>
                        <div style="width: 30%">
                            <label>D.O.B.: YY/MM/DD</label>
                        </div>
                    </div>
                    <div style="display: flex; flex-wrap: nowrap">
                        <div style="width: 50%">
                            <div>
                                <input formControlName="address" type="text" />
                            </div>
                        </div>
                        <div style="width: 50%">
                            <div>
                                <input formControlName="suite" type="text" />
                            </div>
                        </div>
                    </div>
                    <div class="divider"></div>
                    <div style="display: flex; flex-wrap: nowrap">
                        <div style="width: 50%">
                            <label>Address</label>
                        </div>
                        <div style="width: 50%">
                            <label>Suite</label>
                        </div>
                    </div>
                    <div style="display: flex; flex-wrap: nowrap">
                        <div style="width: 50%">
                            <div>
                                <input formControlName="city" type="text" />
                            </div>
                        </div>
                        <div style="width: 50%">
                            <div>
                                <input
                                    formControlName="postalCode"
                                    type="text"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="divider"></div>
                    <div style="display: flex; flex-wrap: nowrap">
                        <div style="width: 50%">
                            <label>City</label>
                        </div>
                        <div style="width: 50%">
                            <label>Postal Code</label>
                        </div>
                    </div>
                    <div style="display: flex; flex-wrap: nowrap">
                        <div style="width: 50%; display: flex; gap: 6px">
                            <input formControlName="homeT" type="text" />
                        </div>
                        <div style="width: 50%; display: flex; gap: 6px">
                            <input formControlName="mobileT" type="text" />
                        </div>
                    </div>
                    <div class="divider"></div>
                    <div style="display: flex; flex-wrap: nowrap">
                        <div style="width: 50%; display: flex; gap: 6px">
                            <label style="white-space: nowrap">Home T </label>
                        </div>
                        <div style="width: 50%; display: flex; gap: 6px">
                            <label style="white-space: nowrap">Mobile T </label>
                        </div>
                    </div>
                    <div style="display: flex; flex-wrap: nowrap">
                        <div style="width: 70%; display: flex; gap: 6px">
                            <input
                                formControlName="healthInsurance"
                                type="text"
                            />
                        </div>
                        <div style="width: 30%; display: flex; gap: 6px">
                            <input type="text" formControlName="sex" />
                        </div>
                    </div>
                    <div class="divider"></div>
                    <div
                        style="
                            display: flex;
                            flex-wrap: nowrap;
                            padding-bottom: 15px;
                        "
                    >
                        <div style="width: 70%; display: flex; gap: 6px">
                            <label style="white-space: nowrap"
                                >#Health Insurance # (if required)</label
                            >
                        </div>
                        <div style="width: 30%; display: flex; gap: 6px">
                            <label style="white-space: nowrap">Sex</label>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="div2 collection-form"
                formGroupName="collectionAgencyInfo"
            >
                <div
                    style="display: flex; flex-direction: column; height: 100%"
                >
                    <div
                        style="
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            padding: 4px;
                        "
                    >
                        <div>www.gtrsante.com</div>
                        <div>514-405-5519</div>
                        <div>help@gtrsante.com</div>
                    </div>
                    <div class="bordered no-border-bottom padding">
                        <div class="header" style="margin-bottom: 15px">
                            Information for collection agency only
                        </div>
                        <div
                            style="
                                display: flex;
                                flex-wrap: nowrap;
                                margin-bottom: 15px;
                            "
                        >
                            <div
                                style="
                                    width: 60%;
                                    display: flex;
                                    flex-wrap: nowrap;
                                    gap: 10px;
                                "
                            >
                                <label
                                    ><b style="white-space: nowrap"
                                        >Collection Date:
                                    </b></label
                                >
                                <input
                                    formControlName="collectionDate"
                                    type="text"
                                    style="border-color: rgb(158, 168, 177)"
                                />
                            </div>
                            <div
                                style="
                                    width: 40%;
                                    display: flex;
                                    flex-wrap: nowrap;
                                    gap: 10px;
                                "
                            >
                                <label
                                    ><b style="white-space: nowrap"
                                        >Time:
                                    </b></label
                                >
                                <input
                                    formControlName="collectionTime"
                                    type="text"
                                />
                            </div>
                        </div>
                        <div style="display: flex; flex-wrap: nowrap">
                            <div
                                style="
                                    width: 60%;
                                    display: flex;
                                    flex-wrap: nowrap;
                                    gap: 10px;
                                "
                            >
                                <label
                                    ><b style="white-space: nowrap"
                                        >Collected by:
                                    </b></label
                                >
                                <input
                                    formControlName="collectedBy"
                                    type="text"
                                />
                            </div>
                            <div
                                style="
                                    width: 40%;
                                    display: flex;
                                    flex-wrap: nowrap;
                                    gap: 10px;
                                "
                            >
                                <label
                                    ><b
                                        style="
                                            color: #82c940;
                                            white-space: nowrap;
                                        "
                                        >Account #:
                                    </b></label
                                >
                                <input
                                    formControlName="accountNumber"
                                    type="text"
                                    style="border-color: #82c940"
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        class="bordered padding no-border-bottom"
                        style="line-height: 190%; flex: 1"
                    >
                        <div style="display: flex; flex-wrap: nowrap">
                            <div
                                style="
                                    width: 40%;
                                    display: flex;
                                    flex-wrap: nowrap;
                                    gap: 10px;
                                    margin-bottom: 5px;
                                "
                            >
                                <label
                                    ><b style="white-space: nowrap"
                                        >Client # :
                                    </b></label
                                >
                                <input
                                    formControlName="clientNumber"
                                    type="text"
                                />
                            </div>
                        </div>
                        <div style="display: flex; flex-wrap: nowrap">
                            <div
                                style="
                                    width: 60%;
                                    display: flex;
                                    flex-wrap: nowrap;
                                    gap: 10px;
                                    margin-bottom: 5px;
                                "
                            >
                                <label
                                    ><b style="white-space: nowrap"
                                        >DOCTOR :
                                    </b></label
                                >
                                <input formControlName="doctor" type="text" />
                            </div>
                            <div
                                style="
                                    width: 40%;
                                    display: flex;
                                    flex-wrap: nowrap;
                                    gap: 10px;
                                    margin-bottom: 5px;
                                "
                            >
                                <label
                                    ><b style="white-space: nowrap"
                                        >#PERMIT :
                                    </b></label
                                >
                                <input
                                    formControlName="permitNumber"
                                    type="text"
                                />
                            </div>
                        </div>
                        <div style="display: flex; flex-wrap: nowrap">
                            <div
                                style="
                                    width: 100%;
                                    display: flex;
                                    flex-wrap: nowrap;
                                    gap: 10px;
                                    margin-bottom: 5px;
                                "
                            >
                                <label
                                    ><b style="white-space: nowrap"
                                        >Clinic :
                                    </b></label
                                >
                                <input formControlName="clinic" type="text" />
                            </div>
                        </div>
                        <div style="display: flex; flex-wrap: nowrap">
                            <div
                                style="
                                    width: 100%;
                                    display: flex;
                                    flex-wrap: nowrap;
                                    gap: 10px;
                                    margin-bottom: 5px;
                                "
                            >
                                <label
                                    ><b style="white-space: nowrap"
                                        >Address :
                                    </b></label
                                >
                                <input formControlName="address" type="text" />
                            </div>
                        </div>
                        <div style="display: flex; flex-wrap: nowrap">
                            <div
                                style="
                                    width: 50%;
                                    display: flex;
                                    flex-wrap: nowrap;
                                    gap: 10px;
                                    margin-bottom: 5px;
                                "
                            >
                                <label
                                    ><b style="white-space: nowrap"
                                        >T:
                                    </b></label
                                >
                                <input formControlName="T" type="text" />
                            </div>
                            <div
                                style="
                                    width: 50%;
                                    display: flex;
                                    flex-wrap: nowrap;
                                    gap: 10px;
                                    margin-bottom: 5px;
                                "
                            >
                                <label
                                    ><b style="white-space: nowrap"
                                        >F:
                                    </b></label
                                >
                                <input formControlName="F" type="text" />
                            </div>
                        </div>
                        <div style="display: flex; flex-wrap: nowrap">
                            <div
                                style="
                                    width: 60%;
                                    display: flex;
                                    flex-wrap: nowrap;
                                    gap: 10px;
                                    margin-bottom: 5px;
                                "
                            >
                                <label
                                    ><b style="white-space: nowrap"
                                        >Dr. SIGNATURE :
                                    </b></label
                                >
                                <img
                                    *ngIf="form.value.signature as signature"
                                    alt="Signature"
                                    height="50px"
                                    [src]="
                                        'assets/signatures/' +
                                        signature +
                                        '.png'
                                    "
                                />
                            </div>
                            <div
                                style="
                                    width: 40%;
                                    display: flex;
                                    flex-wrap: nowrap;
                                    gap: 10px;
                                    margin-bottom: 5px;
                                "
                            >
                                <label
                                    ><b style="white-space: nowrap"
                                        >Date :
                                    </b></label
                                >
                                <input
                                    formControlName="signatureDate"
                                    type="text"
                                    placeholder="AAAA /MM /DD"
                                />
                            </div>
                        </div>
                        <div style="display: flex; flex-wrap: nowrap">
                            <div
                                style="
                                    width: 55%;
                                    display: flex;
                                    flex-wrap: nowrap;
                                    gap: 10px;
                                    margin-bottom: 5px;
                                "
                            >
                                <label
                                    ><b style="white-space: nowrap"
                                        >Copy to Dr.:
                                    </b></label
                                >
                                <input formControlName="copyToDr" type="text" />
                            </div>
                            <div
                                style="
                                    width: 45%;
                                    display: flex;
                                    flex-wrap: nowrap;
                                    gap: 10px;
                                    margin-bottom: 5px;
                                "
                            >
                                <label
                                    ><b style="white-space: nowrap"
                                        >F:
                                    </b></label
                                >
                                <input
                                    formControlName="copyToDrF"
                                    type="text"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="div3 bordered header text-center no-border-right">
                <div class="header text-center">PROFILES</div>
            </div>

            <div class="div4 bordered header text-center">
                <div class="">INDIVIDUAL ANALYSES</div>
            </div>

            <div
                class="profiles div5 padding bordered no-border-top no-border-right"
            >
                <app-qc-profile-checkbox
                    name="TIBCP"
                    label="ANEMIA PROFILE"
                    code="TIBCP"
                >
                    Iron, TIBC, % saturation
                </app-qc-profile-checkbox>
                <app-qc-profile-checkbox
                    name="ANEM1"
                    label="ANEMIA PROFILE #1"
                    code="ANEM1"
                >
                    Hemogram & sedimentation, Iron, TIBC, UIBC, % saturation,
                    vitamin B12, folic acid
                </app-qc-profile-checkbox>
                <app-qc-profile-checkbox
                    name="SMAC"
                    label="BIO-C PROFILE"
                    code="SMAC"
                >
                    Glucose AC, urea, total bilirubin, calcium, creatinine,
                    cholesterol, uric acid, alkaline phosphatase, AST, LDH,
                    total protein, albumin, phosphorus, ALT, GGT, triglycerides
                </app-qc-profile-checkbox>

                <app-qc-profile-checkbox
                    name="SMACLYT"
                    label="BIO-C & Electrolytes PROF."
                    code="SMACLYT"
                >
                    Glucose AC, urea, total bilirubin, calcium, creatinine,
                    cholesterol, uric acid, alkaline phosphatase, AST, LDH,
                    total protein, albumin, phosphorus, ALT, GGT, triglycerides,
                    Na, K, Cl
                </app-qc-profile-checkbox>

                <app-qc-profile-checkbox
                    name="SMA6"
                    label="BIO6 PROFILE"
                    code="SMA6"
                >
                    Glucose AC, urea, creatinine, Na, K, Cl
                </app-qc-profile-checkbox>
                <app-qc-profile-checkbox
                    name="SMA12"
                    label="BIO12 PROFILE"
                    code="SMA12"
                >
                    Albumin, glucose AC, urea, total bilirubin, calcium,
                    creatinine, cholesterol, uric acid, alkaline phosphatase,
                    AST, LDH, total protein
                </app-qc-profile-checkbox>
                <app-qc-profile-checkbox
                    name="SMA12LYT"
                    label="BIO-12&ElectrolytesProfile"
                    code="SMA12LYT"
                >
                    Albumin, glucose AC, urea , total bilirubin, calcium,
                    creatinine, cholesterol, uric acid, alkaline phosphatase ,
                    AST, LDH, total protein Na, K, Cl
                </app-qc-profile-checkbox>
                <app-qc-profile-checkbox
                    name="FERT1"
                    label="FERTILITY PROFILE #1"
                    code="FERT1"
                    [stared]="false"
                >
                    FSH, LH
                </app-qc-profile-checkbox>
                <app-qc-profile-checkbox
                    name="FERT2"
                    label="FERTILITY PROFILE #2"
                    code="FERT2"
                    [stared]="false"
                >
                    FSH, LH, Prolactin
                </app-qc-profile-checkbox>

                <app-qc-profile-checkbox
                    name="LIPID"
                    label="LIPID PROFILE fasting"
                    code="LIPID"
                >
                    Total cholesterol, triglycerides, HDL, LDL Non-HDL-C
                </app-qc-profile-checkbox>
                <app-qc-profile-checkbox
                    name="NFLIPID"
                    label="LIPID PROFILE non-fasting"
                    code="NFLIPID"
                    [stared]="false"
                >
                    Total cholesterol, triglycerides, HDL, LDL, NON HDL-C
                    <div>
                        <ng-container formGroupName="profiles">
                            <input
                                formControlName="NFLIPID_fasting_hours"
                                type="number"
                            />
                        </ng-container>
                        # fasting hours
                    </div>
                </app-qc-profile-checkbox>
                <app-qc-profile-checkbox
                    name="LFT"
                    label="LIVER FUNCTION PROFILE"
                    code="LFT"
                    [stared]="false"
                >
                    ALT, AST, alkaline phosphatase, bilirubin total, LDH, GGT
                </app-qc-profile-checkbox>
                <app-qc-profile-checkbox
                    name="GP1"
                    label="GENERAL PROFILE #1"
                    code="GP1"
                >
                    Glucose AC, urea, total bilirubin, calcium, creatinine,
                    cholesterol, uric acid, alkaline phosphatase, AST, LDH,
                    total protein, albumin, phosphorus, ALT, GGT, triglycerides,
                    hemogram, urinalysis
                </app-qc-profile-checkbox>
            </div>

            <div
                class="profiles div6 padding bordered no-border-top no-border-right"
            >
                <app-qc-profile-checkbox
                    name="GP2"
                    label="GENERAL PROFILE #2"
                    code="GP2"
                >
                    Glucose AC, urea, total bilirubin, creatinine, calcium,
                    cholesterol, uric acid, alkaline phosphatase, AST, LDH,
                    total protein, albumin, phosphorus, ALT, GGT, hemogram,
                    triglycerides, urinalysis, Na, K, Cl
                </app-qc-profile-checkbox>
                <app-qc-profile-checkbox
                    name="GP3"
                    label="GENERAL PROFILE #3"
                    code="GP3"
                >
                    General profile #1(GP1) & HDL-LDL
                </app-qc-profile-checkbox>
                <app-qc-profile-checkbox
                    name="GP4"
                    label="GENERAL PROFILE #4"
                    code="GP4"
                >
                    General profile #2 (GP2) & HDL-LDL
                </app-qc-profile-checkbox>
                <app-qc-profile-checkbox
                    name="HEPAB"
                    label="HEPATITIS A & BScreen"
                    code="HEPAB"
                    [stared]="false"
                >
                    HBsAg, Anti-HBs, Anti-HBc, Anti-HAV IgM
                </app-qc-profile-checkbox>
                <app-qc-profile-checkbox
                    name="HEPB"
                    label="HEPATITIS B Screen"
                    code="HEPB"
                    [stared]="false"
                >
                    HBsAg, Anti-HBs, Anti-HBc
                </app-qc-profile-checkbox>
                <app-qc-profile-checkbox
                    name="MONOP"
                    label="MONOSCREEN PROFILE"
                    code="MONOP"
                    [stared]="false"
                >
                    Hemogram, Monotest
                </app-qc-profile-checkbox>
                <app-qc-profile-checkbox
                    name="OSTEOP"
                    label="OSTEOPOROSIS PROFILE"
                    code="OSTEOP"
                    [stared]="false"
                >
                    <div>
                        <b>Serum</b> ★ Alkaline phosphatase, calcium,
                        creatinine, phosphorus, total protein, ionized calcium,
                        protein electrophoresis, PTH
                    </div>
                    <div>
                        <b>Urine </b>
                        <span style="color: #82c940">≠ </span> Calcium,
                        creatinine, calcium/creatinine ratio, phosphorus
                    </div>
                </app-qc-profile-checkbox>
                <app-qc-profile-checkbox
                    name="PREN1"
                    label="PRENATAL PROFILE"
                    code="PREN1"
                    [stared]="false"
                >
                    Hemogram, blood group & Rh, maternal antibodies
                </app-qc-profile-checkbox>
                <app-qc-profile-checkbox
                    name="FPSA"
                    label="PROSTATE PROFILE"
                    code="FPSA"
                    [stared]="false"
                >
                    PSA Total & Free
                </app-qc-profile-checkbox>
                <app-qc-profile-checkbox
                    name="STONE"
                    label="RENAL STONE PROFILE"
                    code="STONE"
                    [stared]="false"
                >
                    <div>
                        <b>Serum: </b>
                        Calcium, alkaline phosphatase, Na, K, Cl, uric acid
                    </div>
                    <div>
                        <b>24hr Urine: </b> Calcium, phosphate, creatinine, uric
                        acid, oxalate, citrate, sodium, magnesium
                    </div>
                    <div><b>Random urine: </b>urinalysis as indicated</div>
                </app-qc-profile-checkbox>

                <app-qc-profile-checkbox
                    name="TH2"
                    label="THYROID #2 PROFILE"
                    code="TH2"
                    [stared]="false"
                >
                    Free T4, TSH
                </app-qc-profile-checkbox>

                <app-qc-profile-checkbox
                    name="UC"
                    label="URINE PROFILE"
                    code="UC"
                    [stared]="false"
                >
                    Urinalysis & culture
                </app-qc-profile-checkbox>
            </div>

            <div class="div7" style="display: flex; flex-direction: column">
                <div
                    class="div3 bordered header text-center no-border-top no-border-right"
                >
                    Test Specification
                </div>

                <div
                    class="bordered no-border-top no-border-right"
                    style="display: flex; flex-wrap: nowrap; flex: 1"
                >
                    <div class="bordered-right padding">
                        <app-qc-test-specification-checkbox
                            name="PCRCHSD"
                            label="Chlamydia NAAT"
                            [labelBold]="true"
                            code="PCRCHSD"
                            [codeBold]="false"
                        />
                        <app-qc-test-specification-checkbox
                            name="NGONOTAA"
                            label="Gonorrhea NAAT"
                            [labelBold]="true"
                            code="NGONOTAA"
                            [codeBold]="false"
                        />
                        <app-qc-test-specification-checkbox
                            name="TRICHTAA"
                            label="Trichomonas NAAT"
                            [labelBold]="true"
                            code="TRICHTAA"
                            [codeBold]="false"
                        />
                        <app-qc-test-specification-checkbox
                            name="NGPCRD"
                            label="Chlamydia&Gono NAAT"
                            [labelBold]="true"
                            code="PCRCHSD"
                            [codeBold]="false"
                        />
                        <app-qc-test-specification-checkbox
                            name="TGCD"
                            label="Chlamydia, Gono & Trichomonas NAAT"
                            [labelBold]="true"
                            code="TGCD"
                            [codeBold]="true"
                        />
                    </div>

                    <div
                        style="
                            display: flex;
                            align-items: center;
                            margin-top: auto;
                            margin-bottom: auto;
                            font-size: 50px;
                        "
                    >
                        ➡
                    </div>

                    <div class="bordered-left padding">
                        <div style="font-size: 16px; margin-bottom: 15px">
                            <b>Specify source</b>
                        </div>
                        <div style="display: flex; gap: 15px">
                            <app-qc-test-specification-checkbox
                                name="source_cervical"
                                label="Cervical"
                            />
                            <app-qc-test-specification-checkbox
                                name="source_vaginal"
                                label="Vaginal"
                            />
                        </div>
                        <app-qc-test-specification-checkbox
                            name="source_urethral_aptima_swab"
                            label="Urethral Aptima swab"
                        />
                        <app-qc-test-specification-checkbox
                            name="source_urine_sterile_container"
                            label="Urine Sterile container"
                        />
                    </div>
                </div>
            </div>
            <div
                class="div8 bordered no-border-top no-border-right padding"
                formGroupName="testSpecification"
            >
                <div style="font-size: 18px; margin-bottom: 15px">
                    <b>Other Analyses / Instructions:</b>
                </div>

                <textarea
                    formControlName="other_analyses_instructions"
                    rows="4"
                    style="width: 100%; border: none"
                ></textarea>
            </div>
            <div class="div9 bordered no-border-top no-border-right padding">
                <div>
                    <span style="color: #82c940">★ </span> No food or alcohol
                    for 12 hours before collection. Water is permitted.
                </div>

                <div>
                    <span style="color: #82c940">≠,§ </span> For more
                    information visit
                    <a href="http://www.dynacare.ca/">Dynacare.ca </a> or by
                    calling our customer care team at 800.565.5721.
                </div>
            </div>

            <div
                class="analyses div10 bordered no-border-top no-border-right padding"
            >
                <app-qc-individual-analyses-checkbox
                    name="FETO"
                    code="FETO"
                    label="AFP (alpha-fetoprotein)"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="ALB"
                    code="ALB"
                    label="Albumin"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="ALK"
                    code="ALK"
                    label="Alkaline phosphatase"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="ALT"
                    code="ALT"
                    label="ALT"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="AMYL"
                    code="AMYL"
                    label="Amylase"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="ANA"
                    code="ANA"
                    label="ANA"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="DNA"
                    code="DNA"
                    label="Anti-DNA"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="ENA"
                    code="ENA"
                    label="Anti-ENA"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="TAPRO"
                    code="TAPRO"
                    label="Anti-TPO & Anti-thyroglobulin"
                    [small]="true"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="APOA"
                    code="APOA"
                    label="Apolipoprotein A1"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="APOB"
                    code="APOB"
                    label="Apolipoprotein B"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="ASTO"
                    code="ASTO"
                    label="ASOT"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="AST"
                    code="AST"
                    label="AST"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="BSQUAL"
                    code="BSQUAL"
                    label="B-hCG (qualitative)"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="BSQUANT"
                    code="BSQUANT"
                    label="B-hCG(quantitative)"
                    [small]="true"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="BILID"
                    code="BILID"
                    label="Bilirubin direct"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="BILIT"
                    code="BILIT"
                    label="Bilirubin total"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="BLOOD"
                    code="BLOOD"
                    label="Blood Group & Rh"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="CA125"
                    code="CA125"
                    label="CA125"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="CA"
                    code="CA"
                    label="Calcium"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="CEA"
                    code="CEA"
                    label="CEA"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="CHOL"
                    code="CHOL"
                    label="Cholesterol total"
                    [stared]="true"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="CORTIAM"
                    code="CORTIAM"
                    label="Cortisol: 8:00 a.m."
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="CORTIPM"
                    code="CORTIPM"
                    label="Cortisol: 16:00 p.m."
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="CREA"
                    code="CREA+GFRorCREA<18yrs."
                    label="Creatinine"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="CREACL"
                    code="CREACL"
                    label="CreatinineClearance24hUrine"
                    [notEqual]="true"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="CK"
                    code="CK"
                    label="Creatinine kinase"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="CRP"
                    code="CRP"
                    label="CRP"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="CRPHS"
                    code="CRPHS"
                    label="CRP high sensitivity"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="CSC"
                    code="CSC"
                    label="Culture cervix"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="CST"
                    code="CST"
                    label="Culture throat"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="CSV"
                    code="CSV"
                    label="Culture urethral"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="CSU"
                    code="CSU"
                    label="Culture urine"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="CVA"
                    code="CVA"
                    label="Culture vaginal"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox name="CUL">
                    Culture
                    <ng-container formGroupName="individualAnalyses">
                        <input formControlName="CUL_source" type="text" />
                    </ng-container>
                    specify source
                </app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="DIG"
                    code="DIG"
                    label="Digoxin"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="ECG"
                    code="with cardiologist interpretation"
                    label="ECG"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="LYTES"
                    code="LYTES"
                    label="Electrolytes (Na, K, Cl)"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="ESTRA"
                    code="ESTRA"
                    label="Estradiol"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="FERI"
                    code="FERI"
                    label="Ferritin"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="FIT"
                    code="FIT"
                    label="FIT"
                    [notEqual]="true"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="FOL"
                    code="FOL"
                    label="Folate"
                    [stared]="true"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="FRU"
                    code="FRU"
                    label="Fructosamine"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="FSH"
                    code="FSH"
                    label="FSH"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="GGT"
                    code="GGT"
                    label="GGT"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="GLURAN"
                    code="GLURAN"
                    label="Glucose random"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="AC"
                    code="AC"
                    label="Glucose AC"
                    [stared]="true"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="PC50g"
                    code="PC50g"
                    label="Glucose PC 1 h 50g"
                    [stared]="true"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="GLU75"
                    code="GLU75"
                    label="Glucose PC 2 h 75g"
                    [stared]="true"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="PREG75"
                    code="PREG75"
                    label="Glucose PC 2 h 75g Gestational"
                    [stared]="true"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="HPYL"
                    code="HPYL"
                    label="Helicobacter pylori Serology"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="DIA13HELI"
                    code="DIA13HELI"
                    label="Breath"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="HBEL"
                    code="HBEL"
                    label="Hemoglobinel ectrophoresis"
                    [small]="true"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="CBC"
                    code="CBC"
                    label="Hemogram"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="HBA1CP"
                    code="HBA1CP"
                    label="Hemoglobin A1C"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="HEPAG"
                    code="HEPAG"
                    label="Hepatitis A: anti-HAV IgG"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="HEPAM"
                    code="HEPAM"
                    label="Hepatitis A: anti-HAV IgM"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="HBS"
                    code="HBS"
                    label="Hepatitis B: HBsAg"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="ANHBS"
                    code="ANHBS"
                    label="Hepatitis B: Anti-HBs"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="HEPBC"
                    code="HEPBC"
                    label="Hepatitis B: Anti-HBc"
                ></app-qc-individual-analyses-checkbox>
                <app-qc-individual-analyses-checkbox
                    name="HEPC"
                    code="HEPC"
                    label="Hepatitis C: Anti-HCV"
                ></app-qc-individual-analyses-checkbox>
            </div>

            <div class="analyses div11 bordered no-border-top padding">
                <app-qc-individual-analyses-checkbox
                    name="HIV"
                    code="HIV"
                    label="HVI 1-2 (combo)"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="HOLTER24"
                    code="HOLTER24"
                    label="Holter 24hr"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="HOLTER48"
                    code="HOLTER48"
                    label="Holter 48hr"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="HOLTER72"
                    code="HOLTER72"
                    label="Holter 72hr"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="LHOMO"
                    code="LHOMO"
                    label="Homocysteine"
                    [stared]="true"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="ELEPRO"
                    code="ELEPRO"
                    label="Immunofixation"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="IMQUANT"
                    code="IMQUANT"
                    label="Immunoglobulin quantitative"
                    [small]="true"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="LD"
                    code="LD"
                    label="LDH"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="LH"
                    code="LH"
                    label="LH"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="LIP"
                    code="LIP"
                    label="Lipase"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="LI"
                    code="LI"
                    label="Lithium"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="MG"
                    code="MG"
                    label="Magnesium"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="MIALBP"
                    code="MIALBP"
                    label="Micro albumin"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="MONO"
                    code="MONO"
                    label="Monotest"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="UM"
                    code="UM"
                    label="Mycoplasma & Urea plasma"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="PARVOG"
                    code="PARVOG"
                    label="Parvovirus IgG"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="PARVOM"
                    code="PARVOM"
                    label="Parvovirus IgM"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="PCA3"
                    code="PCA3"
                    label="PCA3"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="PHOS"
                    code="PHOS"
                    label="Phosphorus"
                ></app-qc-individual-analyses-checkbox>

                Pregnancy Test
                <div style="margin-left: 24px">
                    <app-qc-individual-analyses-checkbox
                        name="Serum_BSQUAL"
                        code="BSQUAL"
                        label="Serum qualitative"
                        [small]="true"
                    ></app-qc-individual-analyses-checkbox>

                    <app-qc-individual-analyses-checkbox
                        name="PREG"
                        code="PREG"
                        label="Urine qualitative"
                        [small]="true"
                    ></app-qc-individual-analyses-checkbox>

                    <app-qc-individual-analyses-checkbox
                        name="B_hCG_BSQUANT"
                        code="BSQUANT"
                        label="B-hCG serum quantitative"
                        [small]="true"
                    ></app-qc-individual-analyses-checkbox>
                </div>

                <app-qc-individual-analyses-checkbox
                    name="PROG"
                    code="PROG"
                    label="Progesterone"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="PROL"
                    code="PROL"
                    label="Prolactin"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="PROT"
                    code="PROT"
                    label="Protein total"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="PSA"
                    code="PSA"
                    label="PSA Total"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="PT"
                    code="PT"
                    label="PT & INR"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="PTH"
                    code="PTH"
                    label="PTH"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="PTT"
                    code="PTT"
                    label="PTT"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="RA"
                    code="RA"
                    label="Rheumatoid Factor"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="RETICP"
                    code="RETICP"
                    label="Reticulocyte Count"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="RUB"
                    code="RUB"
                    label="Rubella IgG"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="RUBIGM"
                    code="RUBIGM"
                    label="Rubella IgM"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="SED"
                    code="SED"
                    label="Sedimentation Rate"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="SEPTIN9"
                    code="SEPTIN9"
                    label="Septin9"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox name="SPER">
                    Spermogram (SPER)
                    <Span style="color: #82c940">§ </Span> (Main Lab.)
                </app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="SPECO"
                    code="SPECO"
                    label="SpermCount"
                    [notEqual]="true"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="CLOS"
                    code="CLOS"
                    label="Stool: Clostridium difficile"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox name="OP1P_2P_3p"
                    >Stool: Ova & parasites X
                    <ng-container formGroupName="individualAnalyses">
                        <input type="text" formControlName="OP1P_2P_3p_value" />
                    </ng-container>

                    (OP1P, 2P, 3P)
                    <span style="color: #82c940"
                        >≠</span
                    ></app-qc-individual-analyses-checkbox
                >

                <app-qc-individual-analyses-checkbox
                    name="STREP"
                    code="STREP"
                    label="Strep Group A Screen (Rapid &
                    Cult)"
                    [small]="true"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="SYPH"
                    code="SYPH"
                    label="Syphilis"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="T3F"
                    code="T3F"
                    label="T3 Free"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="T3"
                    code="T3"
                    label="T3 Total"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="T4F"
                    code="T4F"
                    label="T4 Free"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="CTX"
                    code="CTX"
                    label="Telopeptide-C "
                ></app-qc-individual-analyses-checkbox>

                Testosterone PRIOR 10:00 a.m.
                <div style="margin-left: 24px">
                    <app-qc-individual-analyses-checkbox
                        name="TESBIO"
                        code="TESBIO"
                        label="Bioavailable"
                    ></app-qc-individual-analyses-checkbox>

                    <app-qc-individual-analyses-checkbox
                        name="TESLI"
                        code="TESLI"
                        label="Free"
                    ></app-qc-individual-analyses-checkbox>

                    <app-qc-individual-analyses-checkbox
                        name="TEST"
                        code="TEST"
                        label="Total"
                    ></app-qc-individual-analyses-checkbox>
                </div>

                <app-qc-individual-analyses-checkbox
                    name="TOXO"
                    code="TOXO"
                    label="Toxoplasmosis IgG "
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="TOXOM"
                    code="TOXOM"
                    label="Toxoplasmosis IgM"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="TRIG"
                    code="TRIG"
                    label="Triglycerides"
                    [stared]="true"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="TSH"
                    code="TSH"
                    label="TSH"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="TSHR4"
                    code="TSHR4"
                    label="TSH reflex"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="UREA"
                    code="UREA"
                    label="Urea"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="URIC"
                    code="URIC"
                    label="Uric acid"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="URI"
                    code="URI"
                    label="Urinalysis"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="URINE_24HR_COLLECTION"
                >
                    Urine 24hr collection
                    <span style="color: #82c940">≠ </span>
                    <ng-container formGroupName="individualAnalyses">
                        <input
                            type="text"
                            formControlName="URINE_24HR_COLLECTION_VALUE"
                        />
                    </ng-container>
                </app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="B12"
                    code="B12"
                    label="Vitamin B12"
                ></app-qc-individual-analyses-checkbox>

                <app-qc-individual-analyses-checkbox
                    name="VITD"
                    code="VITD"
                    label="Vitamin D 25-OH"
                ></app-qc-individual-analyses-checkbox>
            </div>
        </div>
    </form>
</div>
